@if (thumbnailKey) {
  <osp-thumbnail [key]="thumbnailKey" [directImage]="directImage" [customerId]="customerId"/>
} @else {
  <osp-thumbnail-characters [thumbnailLetter]="thumbnailLetter ?? ''" />
}
